import React, { useState } from "react";
import logo from "../assets/images/Logo-Usakti.png";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAxios, API_URL } from "../utils/const";
import toast, { Toaster } from "react-hot-toast";
import { Message } from "primereact/message";
import { Spinner } from "react-bootstrap";
const ConfirmPassword = () => {
  const { id } = useParams();
  const form = useForm();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = form;
  const axiosInstance = useAxios();
  const [loading, setLoading] = useState(false);

  const handleSave = async (formData) => {
    setLoading(true);

    const data = {
      newpassword: formData.password,
      cpassword: formData.confirmation_password,
      token: id,
    };

    try {
      await axiosInstance.post(`${API_URL}/change-password`, data);
      setLoading(false);
      toast.success("Password berhasil diubah. Silakan login kembali");
      navigate("/login");
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      toast.error(errorMessage);
    }
  };
  return (
    <div className="login-page">
      <Toaster position="top-right" />
      <div className="bg-overlay h-100">
        <div className="container-fluid h-100">
          <div
            className="row justify-content-end h-100"
            style={{ alignItems: "center", fontSize: "0.9rem" }}
          >
            <div className="col-lg-5">
              <div
                className="card shadow-lg"
                style={{
                  borderRadius: "3%",
                  paddingTop: "20px",
                  paddingBottom: "120px",
                }}
              >
                <div className="card-body">
                  <div className="header-auth d-flex mx-4 gap-3">
                    <img src={logo} alt="Usakti" height="100" />
                    <h1>Portal Presensi</h1>
                  </div>
                  <div className="row mt-5 text-center">
                    <h5>Reset Password</h5>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-12 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-label fw-semibold">
                          New Password
                        </label>
                        <input
                          {...register("password", {
                            required: "Silakan isi new password!",
                            minLength: {
                              value: 8,
                              message:
                                "Password harus terdiri dari minimal 8 karakter!",
                            },
                          })}
                          type="password"
                          className="form-control form-control-sm"
                        />
                        {errors.password && (
                          <Message
                            style={{ fontSize: "smaller" }}
                            className="w-100 mt-1"
                            severity="error"
                            text={errors.password.message}
                          />
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 mb-3">
                      <div className="form-group">
                        <label htmlFor="" className="form-label fw-semibold">
                          Confirmation Password
                        </label>
                        <input
                          {...register("confirmation_password", {
                            required: "Silahkan isi confirmation password!",
                            minLength: {
                              value: 8,
                              message:
                                "Password harus terdiri dari minimal 8 karakter!",
                            },
                            validate: (value) =>
                              value === watch("password") ||
                              "Konfirmasi password tidak cocok!",
                          })}
                          type="password"
                          className="form-control form-control-sm"
                        />
                        {errors.confirmation_password && (
                          <Message
                            style={{ fontSize: "smaller" }}
                            className="w-100 mt-1"
                            severity="error"
                            text={errors.confirmation_password.message}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        onClick={handleSubmit(handleSave)}
                        className="btn btn-sm rounded btn-primary w-100"
                        disabled={loading}
                      >
                        {loading && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        Reset Password
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPassword;
